import React from 'react';
import { Link } from 'react-router-dom';

const courses = [
  {
    id: 'equity-research',
    title: 'Equity Research & Financial Modeling',
    duration: '5 weeks',
    format: 'Live + Recordings',
    price: 1999,
    description: 'Master equity research through hands-on financial modeling with industry experts.',
    features: ['3-statement modeling', 'DCF valuation', 'Live mentorship'],
    outcomes: ['Build valuation models', 'Write equity research reports', 'Crack finance interviews'],
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71'
  },
  {
    id: 'fixed-income',
    title: 'Fixed Income & Credit Analysis',
    duration: '5 weeks',
    format: 'Live + Recordings',
    price: 2999,
    description: 'Deep-dive into bond valuation and credit risk assessment.',
    features: ['Bond pricing models', 'Credit ratios analysis', 'Default prediction models'],
    outcomes: ['Value bonds accurately', 'Analyze creditworthiness', 'Use Z-score & PD models'],
    image: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74'
  },
  {
    id: 'quantitative-finance',
    title: 'Quantitative Finance',
    duration: '5 weeks',
    format: 'Live + Projects',
    price: 2999,
    description: 'Learn Python for portfolio optimization and risk management.',
    features: ['Python basics', 'Portfolio optimization', 'Monte Carlo simulations'],
    outcomes: ['Build quant models', 'Simulate risk scenarios', 'Understand VaR'],
    image: 'https://images.pexels.com/photos/5716001/pexels-photo-5716001.jpeg'
  }
];

const Programs = () => {
  return (
    <div className="programs-page">

      {/* HERO */}
      <section className="hero programs-hero">
        <div className="container text-center">
          <h1 className="heading-primary mb-lg">Our Programs</h1>
          <p className="text-large text-muted max-w">
            Choose from our comprehensive finance programs designed to accelerate your career growth
          </p>
        </div>
      </section>

      {/* PROGRAM LIST */}
      <section className="section">
        <div className="container">
          <div className="programs-list">
            {courses.map(course => (
              <div key={course.id} className="program-card">

                <div className="program-image">
                  <img src={course.image} alt={course.title} />
                </div>

                <div className="program-content">
                  <span className="course-price">₹{course.price.toLocaleString()}</span>

                  <h2 className="heading-tertiary">{course.title}</h2>

                  <p className="text-sm text-muted">
                    Duration: {course.duration} • Format: {course.format}
                  </p>

                  <p className="text-base">{course.description}</p>

                  <div className="program-lists">
                    <div>
                      <h4>Key Features</h4>
                      <ul className="course-features">
                        {course.features.map((f, i) => <li key={i}>{f}</li>)}
                      </ul>
                    </div>

                    <div>
                      <h4>Learning Outcomes</h4>
                      <ul className="course-features">
                        {course.outcomes.map((o, i) => <li key={i}>{o}</li>)}
                      </ul>
                    </div>
                  </div>

                  <div className="program-actions">
                    <Link to={`/programs/${course.id}`} className="btn btn-primary">
                      View Details
                    </Link>
                    <a
                      href="https://rzp.io/rzp/cGHJ7TZk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Enroll Now
                    </a>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PAGE SCOPED STYLES */}
      <style>{`
        .programs-list {
          display: flex;
          flex-direction: column;
          gap: 3rem;
        }

        .program-card {
          display: grid;
          grid-template-columns: 40% 60%;
          gap: 3rem;
          align-items: stretch;
        }

        .program-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 1.25rem;
          display: block;
        }

        .program-content {
          min-width: 0;
        }

        .program-lists {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          margin-top: 1.5rem;
        }

        .program-actions {
          display: flex;
          gap: 1rem;
          margin-top: 2rem;
          flex-wrap: wrap;
        }

        /* ===== TABLET ===== */
        @media (max-width: 1024px) {
          .program-card {
            grid-template-columns: 1fr;
          }

          .program-image img {
            height: 280px;
          }
        }

        /* ===== MOBILE ===== */
        @media (max-width: 768px) {
          .program-card {
            gap: 2rem;
          }

          .program-lists {
            grid-template-columns: 1fr;
          }

          .program-image img {
            height: 220px;
          }
        }
      `}</style>

    </div>
  );
};

export default Programs;
